/* for spider ssr  */
import React from 'react'
import { ISortProps, ICarProps } from './interface'
import renderList from './car-list-item'

interface Props {
  spiderList: any
}

export default function CarList({ spiderList }: Props) {
  return (
    <React.Fragment>
      {spiderList.series_count === 0 && (
        <div className="empty-tip">抱歉，未找到合适车型</div>
      )}
      <div className="list-wrap">
        <ul className="list tw-grid tw-grid-cols-12 tw-gap-x-12 tw-gap-y-16">
          {spiderList.series.map((item: ICarProps, index: number) =>
            renderList(item, index)
          )}
        </ul>
      </div>
      <style jsx>
        {`
          .list-wrap {
            background: #f2f4fa;
            text-align: center;
            padding-bottom: 36px;
          }
          .empty-tip {
            text-align: center;
            font-size: 16px;
            padding: 80px 0;
            color: #606370;
          }
        `}
      </style>
    </React.Fragment>
  )
}
